module.exports = Object.assign(
  require('./Annex.json'),
  {
  visibility: false,
  defaultItems: {
    // 'SIGFRM': 1
  },
  orderStatuses: require('../OrderStatuses.js'),
  tabs: [
    require('./Tab0-MasterData.js'),
    require('./Tab1-STL.js'),
    require('./Tab2-Attachments.js'),
    require('./Tab3-Cart.js'),
  ],

  productTree: require('../ProductTree.js'),
})
